// ReportingLayout — wrapper for reporting child routes.
// Uses plain Outlet (no inner sidebar). Individual report pages render
// their own content directly. The main sidebar handles report navigation.

import { Outlet } from '@tanstack/react-router'

export function ReportingLayout() {
  return <Outlet />
}
